export default __webpack_public_path__ + "static/moneygram-2ff29745b58d3958e1818a1015458113.png";